import {
  CardPaymentGuards,
  CartGuards,
  FlightExchangeGuards,
  getObjectKeysAsObject,
  ReviewGuards,
} from "@hopper-b2b/checkout";

export const Guards = {
  ...CardPaymentGuards,
  ...CartGuards,
  ...FlightExchangeGuards,
  ...ReviewGuards,
};

export const GuardTypes = getObjectKeysAsObject(Guards);
